import { Alert, Box, Chip, Typography } from '@mui/material';

export type CredentialState =
  | 'REQUESTED'
  | 'PENDING_HANDOFF'
  | 'AWAITING_ACKNOWLEDGMENT'
  | 'FINALIZING'
  | 'ACTIVE'
  | 'CANCELLED'
  | 'EXPIRED'
  | 'FAILED'
  | 'REVOKED';

/** The console accepts and renders control-plane metadata only. */
export interface CredentialWorkflowMetadata {
  request_id: string;
  operation_id: string;
  tenant_id: string;
  agency_account_id: string;
  state: CredentialState;
  role_arn?: string;
  created_at: string;
  updated_at: string;
  rollback_expires_at?: number;
}

export function CredentialStatus({ metadata }: { metadata: CredentialWorkflowMetadata }) {
  const complete = metadata.state === 'ACTIVE';

  return (
    <Alert severity={complete ? 'success' : 'info'} sx={{ mb: 2 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography variant="body2" fontWeight={600}>Credential handoff</Typography>
        <Chip label={metadata.state.replaceAll('_', ' ')} size="small" />
      </Box>
      <Typography variant="caption" display="block">
        Request: {metadata.request_id}
      </Typography>
      {metadata.role_arn && (
        <Typography variant="caption" display="block" sx={{ wordBreak: 'break-all' }}>
          Role ARN: {metadata.role_arn}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" display="block" mt={1}>
        The External ID is available only to the authorized credential custodian through
        the approved handoff channel. It is never returned to or stored by this browser.
      </Typography>
    </Alert>
  );
}
